import React from "react";
import { Integration } from "model/integration";
import { ZapierNewLeadCard } from "./card";
import { ZapierNewLeadModal } from "./modal";

interface Props {
	integration: Integration;
}

interface State {
	modalOpen: boolean;
	testDataSent: boolean;
	name?: string;
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props);
		this.state = {
			modalOpen: false,
			testDataSent: false,
			name: props.integration.name,
		};
	}

	public render() {
		const { integration } = this.props;
		const { modalOpen, testDataSent, name } = this.state;

		return (
			<>
				<ZapierNewLeadCard
					integration={integration}
					onViewIntegration={() => this.setState({ modalOpen: true })}
				/>
				<ZapierNewLeadModal
					open={modalOpen}
					onClose={() => this.setState({ modalOpen: false })}
					integration={integration}
					name={name}
					onNameChange={name => this.setState({ name })}
					testDataSent={testDataSent}
					onTestDataSent={() => {
						this.setState({ testDataSent: true });
						setTimeout(() => this.setState({ testDataSent: false }), 3000);
					}}
				/>
			</>
		);
	}

}

export const ZapierNewLeadIntegration = Component;
